import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';

export interface ValidateCustomOAuthConfigParams {
    customOAuthConfig: string;
    dbClass: string;
}

export interface IValidateCustomOAuthConfigResult extends IGetItemsResult {
  customOAuthConfigId: string;
}

export class ValidateCustomOAuthConfigRequest extends Request<ValidateCustomOAuthConfigParams, IValidateCustomOAuthConfigResult> {
  constructor(params: ValidateCustomOAuthConfigParams) {
    super('validateCustomOAuthConfig', params);
  }
}
